import { OTH, MMD, CPF, ADM, LOC, PSO, FC, PRN, LOCchange, AdmitOrder, DischargeOrder, GeneralOrder, FACchange, PSOorder, PRNOrder, MedicationChange, CPVisitFrequencies, FOR_CAUSE_NAME, LEFT_GEOGRAPHIC_AREA_NAME, NON_CERTIFIED_NAME, DEATH, REVOKED, TRANSFERRED, FOR_CAUSE, LEFT_GEOGRAPHIC_AREA, NON_CERTIFIED } from './orders-constants';
export const ORDERS_MENU = 'Orders';
export const VERBAL_ORDERS_MENU = 'Record Verbal Order';
export const DISCHARGE_MENU = DischargeOrder;
export const IDG_MENU = 'Note for current/next IDG';
export const NEXT_IDG_MENU = 'Note for Next AdHoc IDG';
export const MEDS_MENU = 'Note for Med';
export const CPP_PLANS_MENU = 'Note for CP Problem';
export const CPF_PLANS_MENU = 'Note for CP Frequency';
export const EA_MENU = 'Note for EA';
export const ONE_PER_PAGE = 'One per page';
const onlyHospiceMenu = [{
  name: IDG_MENU
}, {
  name: NEXT_IDG_MENU,
  disabled: true
}, {
  name: MEDS_MENU
}, {
  name: CPP_PLANS_MENU
}, {
  name: CPF_PLANS_MENU,
  onlyHospice: true
}, {
  name: EA_MENU,
  onlyHospice: true
}];
const Menu = [{
  name: IDG_MENU
}, {
  name: NEXT_IDG_MENU,
  disabled: true
}, {
  name: MEDS_MENU
}, {
  name: CPP_PLANS_MENU
}];
const DichargeMenu = [{
  name: DISCHARGE_MENU,
  submenu: [{
    name: 'Expired',
    shortname: DEATH
  }, {
    name: 'Revocation',
    shortname: REVOKED
  }, {
    name: 'Transferred',
    shortname: TRANSFERRED
  }, {
    name: FOR_CAUSE_NAME,
    shortname: FOR_CAUSE
  }, {
    name: LEFT_GEOGRAPHIC_AREA_NAME,
    shortname: LEFT_GEOGRAPHIC_AREA
  }, {
    name: NON_CERTIFIED_NAME,
    shortname: NON_CERTIFIED
  }]
}];
const VerbalOrderOtherMenu = [{
  name: VERBAL_ORDERS_MENU,
  submenu: [{
    name: GeneralOrder,
    shortname: OTH
  }, {
    name: AdmitOrder,
    shortname: ADM,
    disabled: true
  }]
}];
const VerbalOrderReferredMenu = [{
  name: VERBAL_ORDERS_MENU,
  submenu: [{
    name: AdmitOrder,
    shortname: ADM
  }, {
    name: GeneralOrder,
    shortname: OTH
  }]
}];
export const generalMenuHospice = isCPFOrder => isCPFOrder ? [{
  name: VERBAL_ORDERS_MENU,
  submenu: [{
    name: LOCchange,
    shortname: LOC,
    onlyHospice: true
  }, {
    name: FACchange,
    shortname: FC
  }, {
    name: PSOorder,
    shortname: PSO
  }, {
    name: GeneralOrder,
    shortname: OTH
  }, {
    name: MedicationChange,
    shortname: MMD
  }, {
    name: CPVisitFrequencies,
    shortname: CPF
  }, {
    name: PRNOrder,
    shortname: PRN
  }]
}, ...onlyHospiceMenu, ...DichargeMenu] : [{
  name: VERBAL_ORDERS_MENU,
  submenu: [{
    name: LOCchange,
    shortname: LOC,
    onlyHospice: true
  }, {
    name: FACchange,
    shortname: FC
  }, {
    name: PSOorder,
    shortname: PSO
  }, {
    name: GeneralOrder,
    shortname: OTH
  }, {
    name: MedicationChange,
    shortname: MMD
  }]
}, ...onlyHospiceMenu, ...DichargeMenu];
export const generalMenu = isCPFOrder => isCPFOrder ? [{
  name: VERBAL_ORDERS_MENU,
  submenu: [{
    name: FACchange,
    shortname: FC
  }, {
    name: PSOorder,
    shortname: PSO
  }, {
    name: GeneralOrder,
    shortname: OTH
  }, {
    name: MedicationChange,
    shortname: MMD
  }, {
    name: CPVisitFrequencies,
    shortname: CPF
  }, {
    name: PRNOrder,
    shortname: PRN
  }]
}, ...Menu, ...DichargeMenu] : [{
  name: VERBAL_ORDERS_MENU,
  submenu: [{
    name: FACchange,
    shortname: FC
  }, {
    name: PSOorder,
    shortname: PSO
  }, {
    name: GeneralOrder,
    shortname: OTH
  }, {
    name: MedicationChange,
    shortname: MMD
  }]
}, ...Menu, ...DichargeMenu];
export const referredMenuHospice = [...VerbalOrderReferredMenu, ...onlyHospiceMenu];
export const referredMenu = [...VerbalOrderReferredMenu, ...Menu];
export const otherMenuHospice = [...VerbalOrderOtherMenu, ...onlyHospiceMenu];
export const otherMenu = [...VerbalOrderOtherMenu, ...Menu];
export const getRefMenu = ishospice => ishospice ? referredMenuHospice : referredMenu;
export const getOthMenu = ishospice => ishospice ? otherMenuHospice : otherMenu;